import React from 'react';
import tw from 'twin.macro';
import Label from '../Label';

export interface Props {
  id?: string;
  error?: string;
  label?: string;
  labelInfo?: string;
  helperText?: string | React.ReactNode;
  withoutMargin?: boolean;
  className?: string;
  htmlFor?: string;
  ['data-testid']?: string;
  children?: React.ReactNode;
}

export const labelInfoDesign = tw`text-sm text-neutral-moderate`;
export default function FormGroup(props: Props) {
  const {
    error,
    helperText,
    label,
    labelInfo,
    id,
    htmlFor,
    withoutMargin = false,
    children,
    className = '',
  } = props;
  const hasLabel = label || labelInfo;
  return (
    <div
      data-testid={props['data-testid']}
      className={className}
      css={[!withoutMargin && tw`mb-3`]}
    >
      {hasLabel && (
        <div tw="flex justify-between mb-1">
          {label && (
            // eslint-disable-next-line jsx-a11y/label-has-for
            <Label htmlFor={htmlFor} id={id}>
              {label}
            </Label>
          )}
          {labelInfo && <span css={labelInfoDesign}>{labelInfo}</span>}
        </div>
      )}
      {children}
      {(error || helperText) && (
        <p
          css={[
            tw`mt-1 text-sm text-neutral-quiet`,
            error && tw`text-danger-intense`,
            !error && tw`text-xs`,
          ]}
        >
          {error || helperText}
        </p>
      )}
    </div>
  );
}
